import React, { useState } from 'react';
import { toast } from 'react-toastify';
import { Button, Form, Header, Message, Segment } from 'semantic-ui-react';
import { agent } from '../../app/api/agent';
// Import your translation function - adjust the import path as needed
import { useTranslation } from 'react-i18next'; // or your preferred i18n library

interface ForgotPasswordFormProps {
  onClose?: () => void;
}

export const ForgotPasswordForm: React.FC<ForgotPasswordFormProps> = ({ onClose }) => {
  const { t } = useTranslation(); // or your translation hook
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [sent, setSent] = useState(false);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    
    if (!email) {
      toast.error(t('forgotPassword.errors.emailRequired'));
      return;
    }

    setLoading(true);
    try {
      await agent.Account.forgotPassword({ email });
      setSent(true);
      toast.success(t('forgotPassword.errors.resetSuccess'));
    } catch (error: any) {
      toast.error(error.response?.data?.message || t('forgotPassword.errors.resetFailed'));
    } finally {
      setLoading(false);
    }
  };

  if (sent) {
    return (
      <Segment textAlign="center" padded>
        <Header as="h3" color="green" icon="checkmark" content={t('forgotPassword.success.title')} />
        <Message positive>
          <p>{t('forgotPassword.success.message')} <strong>{email}</strong></p>
        </Message>
        <Button primary onClick={onClose} content={t('forgotPassword.success.closeButton')} />
      </Segment>
    );
  }

  return (
    <Segment padded>
      <Header as="h3" content={t('forgotPassword.form.title')} color="teal" />
      <p>{t('forgotPassword.form.description')}</p>
      
      <Form onSubmit={handleSubmit}>
        <Form.Field required>
          <label>{t('forgotPassword.form.emailLabel')}</label>
          <Form.Input
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            placeholder={t('forgotPassword.form.emailPlaceholder')}
            disabled={loading}
          />
        </Form.Field>
        
        <div style={{ marginTop: '20px', textAlign: 'center' }}>
          <Button 
            type="submit" 
            primary
            loading={loading}
            disabled={loading}
            content={loading ? t('forgotPassword.form.buttons.sending') : t('forgotPassword.form.buttons.sendReset')}
            style={{ marginRight: '10px' }}
          />
          
          {onClose && (
            <Button 
              type="button" 
              basic
              onClick={onClose}
              disabled={loading}
              content={t('forgotPassword.form.buttons.cancel')}
            />
          )}
        </div>
      </Form>
    </Segment>
  );
};